import { useState } from "react";
import { Modal } from "react-bootstrap";
import { useLanguage } from "../Translations/LenguageContext";
import FormatDateTime from "../Functions/FormatDate";
import { LuTestTubeDiagonal, LuTrash2 } from "react-icons/lu";
import { TbLogs } from "react-icons/tb";

const OpenContextModal = ({
    show,
    handleClose,
    selectedSource,
    setOpenDeleteItem,
    setOpenLogs,
    setOpenTestModal
}) => {
    const { t } = useLanguage()
    const [loadingSave, setLoadingSave] = useState(false);
    const [errorMessage, setErrorMessage] = useState({ message: "", display: false });

    const closeModal = () => {
        handleClose();
        setErrorMessage({ message: "", display: false });
        setLoadingSave(false);
    };

    const handleDelete = () => {
        setOpenDeleteItem(true)
        closeModal()
    }

    const handleOpenLogs = () => {
        setOpenLogs(true)
        closeModal()
    }

    const handleOpenTest = () => {
        setOpenTestModal(true)
        closeModal()
    }

    return (
        <Modal show={show} centered onHide={closeModal}>
            <div className="modal_header">
                <p className="modal_header_title">
                    {selectedSource?.source_type
                        ?.charAt(0)
                        .toUpperCase() + selectedSource?.source_type?.slice(1)}
                </p>
                <button className="context_window_footer_btn_delete fade-in" onClick={() => handleDelete()}><LuTrash2 /></button>
            </div>
            <div className="modal_main_cont">
                <div className="modal_profile_input_cont">
                    {Object.entries(selectedSource || {})
                        .sort(([keyA], [keyB]) => {
                            const dateFields = [
                                "created_at",
                                "last_synced_at",
                                "updated_at",
                            ];

                            const indexA = dateFields.indexOf(keyA);
                            const indexB = dateFields.indexOf(keyB);

                            if (indexA === -1 && indexB === -1) return 0;
                            if (indexA === -1) return -1;
                            if (indexB === -1) return 1;

                            return indexA - indexB;
                        })
                        .map(([key, value]) => {
                            const dateFields = [
                                "created_at",
                                "last_synced_at",
                                "updated_at",
                            ];

                            const label = key;

                            return (
                                <div className="label_input" key={key}>
                                    <label className="input_label">
                                        {label === "updated_at"
                                            ? t[label]
                                            : (t.context[label] ??
                                                (key === "source_urls"
                                                    ? "Sources"
                                                    : key.replace(/_/g, " ")))}
                                    </label>

                                    {key === "source_urls" &&
                                        Array.isArray(value) ? (
                                        <div className="source_urls_list">
                                            <p className="source_url_item">
                                                {value.length}{" "}
                                                {selectedSource.source_type ===
                                                    "website"
                                                    ? value.length === 1
                                                        ? "URL"
                                                        : "URLs"
                                                    : value.length === 1
                                                        ? "File"
                                                        : "Files"}
                                            </p>
                                        </div>
                                    ) : (
                                        <div className="input_value">
                                            {key === "status" && (
                                                <>
                                                    <span
                                                        className={`status_dot ${value === "COMPLETED"
                                                            ? "active"
                                                            : value === "FAILED"
                                                                ? "error"
                                                                : "uploading"
                                                            }`}
                                                    />

                                                    {t.context[value] ?? value}
                                                </>
                                            )}

                                            {key !== "status" &&
                                                (dateFields.includes(key)
                                                    ? value
                                                        ? FormatDateTime(value)
                                                        : "—"
                                                    : Array.isArray(value)
                                                        ? value.join(", ")
                                                        : value ?? "—")}
                                        </div>
                                    )}
                                </div>
                            );
                        })}
                </div>
                <div className="context_logs_btn_cont">
                    {(selectedSource?.status != "QUEUED") && (
                        <button
                            className="context_logs_btn fade-in"
                            onClick={() => handleOpenLogs()}
                        >
                            <TbLogs />
                            {t.context.view_logs_btn}
                        </button>
                    )}
                    {(selectedSource?.status != "QUEUED" || selectedSource?.status != "RUNNING") && (
                        <button
                            className="context_logs_btn fade-in"
                            onClick={() => handleOpenTest()}
                        >
                            <LuTestTubeDiagonal />
                            {t.context.source_overview}
                        </button>
                    )}
                </div>
            </div>
            <div className="modal_footer">
                <div className="modal_footer_err_cont">
                </div>
                <div className="modal_footer_btn_cont">
                    <button
                        className="modale_close_btn"
                        onClick={closeModal}
                        disabled={loadingSave}
                    >
                        {t.close}
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default OpenContextModal;